import gql from 'graphql-tag';

export default gql`
  query showFeaturedCollection(
    $id: ID!
  ) {
    showFeaturedCollection(
      id: $id
    ) {
      description
      id
      name
      studySets {
        id
        title
      }
    }
  }
`;
